import { useEffect, useState } from 'react';

var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0
};

export const useGetLocationPermissionStatus = () => {
  const [status, setStatus] = useState<'denied' | 'prompt' | 'granted'>('denied');

  const successCallback = () => {
    setStatus('granted');
  };

  const errorCallback = (error: GeolocationPositionError) => {
    window.location.href = 'app-settings:location';
    // eslint-disable-next-line no-console
    console.warn(error);
  };

  const grantGeoAccess = () => {
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
  };

  useEffect(() => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      const newStatus = result.state;
      setStatus(newStatus);
      result.addEventListener('change', () => {
        setStatus(newStatus);
      });
    });
  }, []);

  return { status, grantGeoAccess };
};
